mutation RemoveQAAnnotationFromComputedDeliverable($annotationId: ID!) {
    removeQAAnnotationFromComputedDeliverable(annotationId: $annotationId)
}
